import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import mapboxgl from 'mapbox-gl'
import ReactMapboxGl, { Marker } from 'react-mapbox-gl'

import { useSelector } from 'react-redux'

import { getSecret } from '../../../../utils/i18n/secret'
import { selectUserGeolocation } from '../../../../flux/selectors/user'

require('mapbox-gl/dist/mapbox-gl.css')

const mapStyle = {
  height: '100%',
  width: '100%',
}

const StyledPin = styled.img(({ size }) => ({
  width: size,
  height: 'auto',
}))

const DynamicMap = ({ markers, isControlsEnabled }) => {
  const center = useSelector(selectUserGeolocation)
  const ReactMap = ReactMapboxGl({
    apiUrl: getSecret('MAP_TILE_URL')(),
    interactive: isControlsEnabled,
  })

  const onStyleLoad = map => {
    const bounds = new mapboxgl.LngLatBounds()
    if (center?.lng && center?.lat) {
      bounds.extend([center.lng, center.lat])
    }

    if (markers.length) {
      markers.forEach(({ lat, lng }) => {
        if (lat && lng) {
          bounds.extend([lng, lat])
        }
      })
    }

    map.fitBounds(bounds, { padding: 30 })
  }

  return (
    <ReactMap
      onStyleLoad={onStyleLoad}
      center={[(center.lng), (center.lat)]}
      style={getSecret('MAP_TILE_URL')()}
      containerStyle={mapStyle}
    >
      <>
        <Marker coordinates={[(center.lng), (center.lat)]}>
          <StyledPin size="30" src={`${process.env.PUBLIC_URL}/img/pin/marker.svg`} />
        </Marker>
        {
          markers.map(({ lat, lng, pin }) => (
            <Marker key={`${lat}${lng}`} coordinates={[(lng), (lat)]}>
              <StyledPin size="40" src={pin} />
            </Marker>
          ))
        }
      </>
    </ReactMap>
  )
}

DynamicMap.propTypes = {
  markers: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    lng: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    pin: PropTypes.string,
  })),
  isControlsEnabled: PropTypes.bool,
}

DynamicMap.defaultProps = {
  markers: [],
  isControlsEnabled: true,
}

export default React.memo(DynamicMap)
